module.exports = __webpack_public_path__ + "img/workshop1.0e4ee019.jpg";